import { HttpResponse } from '@angular/common/http';

export function downloadChecklistFileResponse(response: HttpResponse<Blob>, fallbackFileName: string): void {
  if (!response.body) {
    return;
  }

  const url = URL.createObjectURL(response.body);
  const link = document.createElement('a');
  link.href = url;
  link.download = getContentDispositionFileName(response.headers.get('Content-Disposition')) || fallbackFileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function getContentDispositionFileName(contentDisposition: string | null): string | null {
  const encodedMatch = contentDisposition?.match(/filename\*=UTF-8''([^;]+)/i);
  if (encodedMatch?.[1]) {
    return decodeURIComponent(encodedMatch[1]);
  }

  const match = contentDisposition?.match(/filename="?([^";]+)"?/i);
  return match?.[1] || null;
}
